/**
 * Outsourcing-contract drawer link section (P340).
 *
 * Which services this contract underpins -- contract-grain third-party
 * coverage over the generic LinkSection primitive (the P15.3 shape).
 */
import { LinkSection } from "./LinkSection";

export function ContractServiceLinks({ rowId }: { rowId: string }) {
  return (
    <LinkSection
      i18nPrefix="modules.foundation.admin.outsourcingContracts.serviceLinks"
      listEndpoint={`/v1/admin/foundation/outsourcing-contracts/${rowId}/services`}
      deleteEndpoint={(serviceId) =>
        `/v1/admin/foundation/outsourcing-contracts/${rowId}/services/${serviceId}`
      }
      optionsEndpoint="/v1/admin/foundation/services?limit=500"
      targetFieldKey="service_id"
      queryKey={
        ["foundation-admin", "outsourcing-contracts", rowId, "services"] as const
      }
      optionsQueryKey={["foundation-admin", "service", "parent-options"] as const}
    />
  );
}

/**
 * P400 -- the fourth parties behind this arrangement.
 *
 * A fourth party is a Vendor row, deliberately: a company can be both a
 * direct supplier and a subcontractor of another supplier, which is the
 * worst concentration case rather than an edge case. `role` is captured
 * at the point the link is made, because "who" without "what" does not
 * support a substitutability judgement.
 *
 * The contract's free-text `subcontractors` field is NOT replaced -- it
 * holds narrative a link cannot, and a bank cannot always name a fourth
 * party precisely. The `subcontractors_are_modelled` standard flags any
 * contract that names them in prose without modelling them here.
 */
export function ContractSubcontractorLinks({ rowId }: { rowId: string }) {
  return (
    <LinkSection
      i18nPrefix="modules.foundation.admin.outsourcingContracts.subcontractorLinks"
      listEndpoint={`/v1/admin/foundation/outsourcing-contracts/${rowId}/subcontractors`}
      deleteEndpoint={(vendorId) =>
        `/v1/admin/foundation/outsourcing-contracts/${rowId}/subcontractors/${vendorId}`
      }
      optionsEndpoint="/v1/admin/foundation/vendors?limit=500"
      targetFieldKey="vendor_id"
      displayFieldKey="role"
      createExtraFieldKey="role"
      queryKey={
        ["foundation-admin", "outsourcing-contracts", rowId, "subcontractors"] as const
      }
      optionsQueryKey={["foundation-admin", "vendor", "parent-options"] as const}
    />
  );
}
